export const environment = {
  production: false,
  locales: ['ua', 'en'],
  defaultLocale: 'ua',
  firebase: {
    apiKey: 'AIzaSyAEE4jcEvBv0JXj7z67P5W-ib1X0fiAsxU',
    authDomain: 'sport-league-ca78f.firebaseapp.com',
    projectId: 'sport-league-ca78f',
    storageBucket: 'sport-league-ca78f.appspot.com',
    messagingSenderId: '188073154148',
    appId: '1:188073154148:ios:0dbea6f997f2e98b967171'
  },
  contacts: {
    website: 'https:///',
    email: 'info@info.info',
    phone: '555-555-5555',
    instagram: 'https://www.instagram.com/',
    facebook: 'https://www.facebook.com/',
    twitter: 'https://twitter.com/'
  }
};
